import { useMutation, useQueryClient } from '@tanstack/react-query';
import profileService, { ProfileUpdateData, PasswordUpdateData } from '../services/profileService';
import { User } from '../services/authService';

export const useProfile = () => {
  const queryClient = useQueryClient();

  // Update profile mutation
  const updateProfileMutation = useMutation({
    mutationFn: profileService.updateProfile,
    onSuccess: (data) => {
      // Update user in cache
      queryClient.setQueryData(['user'], data.user);
      
      // Update user in localStorage
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        const user = JSON.parse(storedUser) as User;
        localStorage.setItem('user', JSON.stringify({
          ...user,
          ...data.user
        }));
      }
    }
  });

  // Update password mutation
  const updatePasswordMutation = useMutation({
    mutationFn: profileService.updatePassword
  });

  return {
    updateProfile: (data: ProfileUpdateData) => updateProfileMutation.mutateAsync(data),
    updatePassword: (data: PasswordUpdateData) => updatePasswordMutation.mutateAsync(data),
    isUpdating: updateProfileMutation.isPending,
    isUpdatingPassword: updatePasswordMutation.isPending,
    error: updateProfileMutation.error || updatePasswordMutation.error
  };
}; 